


















import Vue, { PropType } from 'vue'
import { Widget } from '../base/'

import { DateTimeService } from '../../../base/services/DateTimeService'
import { VehicleStatusLog } from '../../../base/store/state.interface'

import VehicleStatusHistoryItem from './VehicleStatusHistoryItem.vue'
import NoWidgetAccess from '../../components/NoWidgetAccess.vue'

export default Vue.extend({
  components: {
    VehicleStatusHistoryItem,
    NoWidgetAccess,
  },
  props: {
    widget: {
      required: true,
      type: Object as PropType<Widget>
    }
  },
  computed: {
    showTitle() {
      return this.widget?.customSettings?.settings.showTitle.checked
    },
    orderedVehicleStatusMessages() {
      const vehicleStatus = this.$store.state.vehicle_status_history

      if (!vehicleStatus.isInitialised || !this.widget) {
        return []
      }

      let result: any[] = []
      const cluster = this.$store.state.cluster
      const vehicles = cluster.vehicle
      const statusMessages = cluster.fms_status.items
      const history = vehicleStatus.history
      const widgetSettings = this.widget.customSettings!.settings
      const widgetData = widgetSettings.vehicles.data
      const displayMode = widgetData.displayMode || '1'
      const selectedVehicles = widgetData.vehicles || []

      for (const vehicleId in history) {
        if (
          !history.hasOwnProperty(vehicleId) ||
          ((displayMode !== '1') && (selectedVehicles.indexOf(parseInt(vehicleId, 10)) === - 1)) ||
          !vehicles[vehicleId]
        ) {
          continue
        }

        const vehicle = vehicles[vehicleId]

        history[vehicleId].forEach((log: VehicleStatusLog) => {
          const vehicleStatus = statusMessages[log.status_id]

          if (!vehicleStatus) {
            return
          }

          const record = {
            vehicle: vehicle.shortname,
            radioName: vehicle.name,
            statusNumber: vehicleStatus.number,
            statusText: vehicleStatus.name,
            statusColor: vehicleStatus.color_hex,
            date: DateTimeService.humanizeTimestamp(log.ts),
            text: log.status_note,
            ts: log.ts
          }

          result.push(record)
        })
      }

      // order history descending by timestamp
      result.sort((a, b) => b.ts - a.ts)

      const maxEntries = widgetSettings.maxlength.value

      return maxEntries > 0 ? result.slice(0, maxEntries) : result
    }
  }
})
